import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FieldType } from '@ngx-formly/core';
import { countries, getCountryData } from 'countries-list';

@Component({
  selector: 'app-formly-country',
  template: `
    <p-select
      [options]="countries"
      optionLabel="name"
      [showClear]="true"
      [filter]="true"
      filterBy="name"
      dataKey="code"
      [placeholder]="props.placeholder ?? props.label"
      [formControl]="countryControl"
      [appendTo]="props['appendTo'] || null"
      class="w-full"
    >
      <ng-template #selectedItem let-selectedOption>
        <div class="flex items-center gap-2" *ngIf="countryControl.value">
          <span
            class="fi fi-{{
              countryControl.value.code.toLowerCase()
            }} mr-1 ml-1"
            style="font-size: 1.1rem;"
          ></span>
          <div>{{ countryControl.value.name }}</div>
        </div>
      </ng-template>
      <ng-template let-country #item>
        <div class="flex items-center gap-2">
          <span
            class="fi fi-{{ country.code.toLowerCase() }} mr-2"
            style="font-size: 1.1rem;"
          ></span>
          <div>{{ country.name }}</div>
        </div>
      </ng-template>
    </p-select>
  `,
  styles: [``],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyCountryComponent extends FieldType implements OnInit {
  countryControl: FormControl = new FormControl();

  get control(): FormControl {
    return this.formControl as FormControl;
  }

  countries: any[] = [];

  ngOnInit() {
    this.countries = Object.entries(countries)
      .map(([code, data]) => ({
        code,
        ...data,
      }))
      .sort((a, b) => {
        // Put US first
        if (a.code === 'US') return -1;
        if (b.code === 'US') return 1;
        return a.name.localeCompare(b.name);
      });

    this._syncFromControl(this.formControl.value);

    this.countryControl.valueChanges.subscribe(country => {
      this.formControl.setValue(country?.code ?? null);
    });

    // Reflect external/programmatic value changes (e.g. prefill on edit, where
    // formly reuses this component so ngOnInit doesn't re-run).
    this.formControl.valueChanges.subscribe(code => {
      if ((code ?? null) !== (this.countryControl.value?.code ?? null)) {
        this._syncFromControl(code);
      }
    });
  }

  private _syncFromControl(code: string | null | undefined) {
    if (code) {
      this.countryControl.setValue(
        { code, ...getCountryData(code as any) },
        { emitEvent: false },
      );
    } else {
      this.countryControl.setValue(null, { emitEvent: false });
    }
  }

  constructor() {
    super();
  }
}
